import { BasicPrivateOfferVO } from "./BasicPrivateOfferVO";
import { PrivateOfferStateEnum } from "./PrivateOfferStateEnum";

import { IOfferDescription } from "./offerDescriptions/IOfferDescription";
import { IPrivateOfferModel } from "./offerQuestConditions/IPrivateOfferModel";
import { OfferQuestConditionContainer } from "./offerQuestConditions/OfferQuestConditionContainer";
import { OfferQuestConditionLogicEnum } from "./offerQuestConditions/OfferQuestConditionLogicEnum";

export class BasicPrivateOfferVOFactory {
    protected privateOfferData: IPrivateOfferModel;

    constructor(model: IPrivateOfferModel) {
        this.privateOfferData = model;
    }

    /******************************************
     * Creating offer from server information *
     ******************************************/
    /**
     * Create a new offer with given parameter
     * @param paramObj
     * @return
     */
    public createOfferFromParams(paramObj: any): BasicPrivateOfferVO {
        let newOffer: BasicPrivateOfferVO = new BasicPrivateOfferVO();
        this.fillFromParamObject(newOffer, paramObj.O);
        return newOffer;
    }

    public fillFromParamObject(privateOfferVO: BasicPrivateOfferVO, paramObj: any): void {
        let description: Map<any, any> = null;
        let id: number = parseInt(paramObj.OID); 		// offer ID
        let offerState: PrivateOfferStateEnum = PrivateOfferStateEnum.getEnumByServerEventID(parseInt(paramObj.OS));	// current offer state
        let endTimestamp: number = -1;
        let hasInfiniteTime: boolean = false;
        let _questConditions: OfferQuestConditionContainer;

        if (paramObj.RS)		// check Remaining Seconds
        {
            // 1000 = seconds to milliseconds conversion
            endTimestamp = Date.now() + parseInt(paramObj.RS) * 1000; //Constants_Time.SEC2MILLISEC;
            hasInfiniteTime = false;	// if remaining seconds sent by server, time is not infinite
        }
        else {   // infinite time, endTimestamp = -1
            hasInfiniteTime = true;	// if remaining seconds not set by server, time for this offer step is infinite
        }

        // offer description
        let idString: string;
        let value: any;

        description = new Map<any, any>();

        if (paramObj.OD)                     	// read all offer descriptions and crate description lists
        {
            for (idString in paramObj.OD) {
                value = paramObj.OD[id];
                let offerDescription: IOfferDescription = this.privateOfferData.createOfferDescriptionObject(idString, value);
                if (offerDescription) {
                    description.set(id, offerDescription);
                }
            }
        }

        // offer quest description
        if (paramObj.QD)		// first level of offer quest conditions are saved as "conditions", so create an offer quest condition container
        {
            _questConditions = (<OfferQuestConditionContainer>this.privateOfferData.createQuestConditionContainer(paramObj.QD, OfferQuestConditionLogicEnum.getConditionLogicByName(paramObj.QD.logic)));
        }
    }

    public dispose(): void {
        this.privateOfferData = null;
    }

}

